import { createFilterStore } from './createFilterStore';

export const useDealFilterStore = createFilterStore({
  page: 1,
  limit: 20,
  search: '',
  status: '',
  pipelineId: '',
  stageId: '',
  assignedToId: '',
  companyId: '',
  sortBy: 'createdAt',
  sortOrder: 'desc' as const,
});
